import { useWindowDimensions } from '@/shared/hooks/useWindowDimension';
import { Capacitor } from '@capacitor/core';
import { getPlatforms } from '@ionic/react';

export const useIsMobile = () => {
  const { isMobileView } = useWindowDimensions();
  const isApp = Capacitor.isNativePlatform();
  const isMobileWeb = !getPlatforms().includes('desktop') || isMobileView;

  return isMobileWeb || isApp;
};
